var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"dense":"","expand":""}},_vm._l((_vm.themes),function(theme){return _c('select-theme',{key:theme.id,attrs:{"theme":theme,"selected":_vm.value},on:{"toggle":_vm.toggle}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }